import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import {
  nowBasicCheckRespIsEligibleOrMinimumValueNotReached,
  useNowGeneralContext,
} from '../../../../../../now'
import { useProductPageContext } from '../../../../productPageContext'
import { ProductHeadGenericLabel } from '../../ProductHeadGenericLabel/ProductHeadGenericLabel'

export const ProductHeadNowLabel: FC = () => {
  const { nowDetails } = useProductPageContext()

  const { productPageNowDialogControls } = useNowGeneralContext()

  const nowEligible = nowBasicCheckRespIsEligibleOrMinimumValueNotReached(
    nowDetails.nowDataPerProductCurrentVariantResponse,
  )

  return (
    <ProductHeadGenericLabel
      className={clsx(
        nowEligible && 'bg-light-primary-medium text-dark-primary-max',
        !nowEligible && 'border-dark-primary-min bg-light-primary-low',
      )}
      data-qa-id="now-product-label"
      hasBorder={!nowEligible}
      onClick={productPageNowDialogControls.handleOpen}
    >
      <FormattedMessage id="product.label.nowProductGroup" />
      <IconInfo className="ml-2 size-4" />
    </ProductHeadGenericLabel>
  )
}
